// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/data-formatting/truncate.directive.scss
// module id = 197
// module chunks = 0